<template>
  <div class="page-container">
    <el-carousel height="585px">
      <el-carousel-item :interval="5000" arrow="always" v-for="item in bannerList" :key="item.index">
        <a class="slider-item" href="javascript:;">
          <img class="item-img" :src="item.src" />
        </a>
      </el-carousel-item>
    </el-carousel>
    <div class="section">
      <div class="new-list">
        <div class="news-item new-item-lg" v-for="(item,index) in list" :key="index">
          <div class="news-item-link">
            <el-row class="row">
              <el-col :span="8">
                <div class="picture">
                  <div class="img" :style="'background-image:url('+ item.faceimage+')'"></div>
                </div>
              </el-col>
              <el-col :span="16">
                <div class="info">
                  <div class="title-row">
                    <router-link :to="{path:'/news/detail',query:{id:item.id}}" class="title">{{item.title}}</router-link>
                    <span class="news-price">资讯 1元/条</span>
                  </div>
                  <div class="dec">{{item.content}}</div>
                  <div class="date">发布时间：{{item.createtime}}</div>
                  <div class="info-tools">
                    <router-link :to="{path:'/news/detail',query:{id:item.id}}" class="more">查看详情》</router-link>
                    <span class="comment"><span class="comment-item"><i>{{item.userLikeCount ||  0}}</i></span><span class="comment-item"><i>{{item.readcount ||  0}}</i></span></span>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <el-link class="btn-more" :underline="false" disabled v-if="isend">没有更多了</el-link>
      <el-link class="btn-more" :underline="false" @click="getInfomationList" v-if="!isend">加载更多</el-link>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@import "../../assets/news.scss";
.section {
  margin-top: 20px;
  padding: 20px;
  box-shadow: 0px 1px 7px 0px rgba(11, 3, 6, 0.3);
  border-radius: 8px;
}

.news-item-link .title-row {
  position: relative;
  padding-right: 90px; /* 预留标签空间，避免与标题重叠 */
}
.news-item-link .title-row .news-price {
  position: absolute;
  right: 0;
  bottom: 0;
  color: #bc230c;
  font-size: 14px;
  white-space: nowrap;
}

</style>
<script>
import {
  News
} from "../../model/news.js";
let news = new News();
export default {
  name: 'index',
  data() {
    return {
      iscur: 2,//资讯类型 2：长资讯，3：展览
      bannerList: [
        { src: require('../../assets/image/banner1.png'), index: 'ddd0' },
        { src: require('../../assets/image/banner3.jpg'), index: 'ddd1' },
        { src: require('../../assets/image/download.jpg'), index: 'ddd2' }
      ],
      list: [],
      pageIndex: 1,
      pageSize: 10,
      isend: false
    }
  },
  components: {

  },
  methods: {
    getInfomationList() {
      let _this = this;
      return new Promise(function (resolve, reject) {
        news.infomationList({
          UnionId: "123",
          InfoType: _this.iscur,
          PageIndex: _this.pageIndex,
          PageSize: _this.pageSize
        }).then((res) => {
          let list = res.data;
          if (list.length < _this.pageSize || list.length == 0) {
            _this.isend = true
          }
          _this.list = list.length > 0 ? _this.list.concat(list) : _this.list;
          _this.pageIndex++;
          resolve()
        }, () => {
          reject()
        })
      })
    }
  },
  created() {
    this.getInfomationList();
  }
}
</script>